window.__preventScrollTrigger = '1';
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: this.querySelectorAll('.slider-dot'),
        };
        this.mql = window.matchMedia('(min-width: 768px)');

        if (this.elements.dots.length > 0) {
          this.elements.dots.forEach((dot) => {
            dot.addEventListener('click', (e) => {
              const index = parseInt(dot.dataset.index);
              const sliderComponent = this.elements.viewer;
              if (sliderComponent && sliderComponent.sliderItemsToShow) {
                const slide = sliderComponent.sliderItemsToShow[index];
                if (slide) {
                  sliderComponent.slider.scrollTo({ left: slide.offsetLeft });
                }
              }
            });
          });
        }

        if (!this.elements.thumbnails) return;
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      // onSlideChanged(event) {
      //   const thumbnail = this.elements.thumbnails.querySelector(
      //     `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      //   );
      //   this.setActiveThumbnail(thumbnail);
      // }
      onSlideChanged(event) {
        const currentElement = event?.detail?.currentElement;
        if (!currentElement || !currentElement.dataset?.mediaId) {
          return;
        }
        const mediaId = currentElement.dataset.mediaId;
        const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
        if (thumbnail) {
          this.setActiveThumbnail(thumbnail);
        }
        if (this.elements.dots && this.elements.dots.length > 0) {
          this.elements.dots.forEach((dot, index) => {
            if (index === event.detail.currentPage - 1) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }
      }
      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');
        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
           if (window.__preventScrollTrigger == '0') {
           }else{
          if (this.dataset.quick != 'quickv') { window.scrollTo({ top: top, behavior: 'smooth' }); }
           }
        });
        this.playActiveMedia(activeMedia);

        const activeSlideIndex = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).indexOf(activeMedia);
        if (activeSlideIndex !== -1 && this.elements.dots && this.elements.dots.length > 0) {
          this.elements.dots.forEach((dot, index) => {
            if (index === activeSlideIndex) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        // Check if activeThumbnail is null before proceeding
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
        }
        this.announceLiveRegion(activeMedia, activeThumbnail ? activeThumbnail.dataset.mediaPosition : '');
      }
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.setSlidePosition(thumbnail[this.elements.thumbnails.offsetPosition]);
      }
      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }
      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }
      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}